module.exports = __webpack_public_path__ + "img/john.751b4115.jpg";